import {Directive, ElementRef, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {UserService} from '../services/user.service';
import {EventTrackerService, UserActionType} from '../services/event-tracker/event-tracker.service';
import {BlockedReason, InvalidAction, WallType} from '../../models/user';

@Directive({
  selector: '[actionByLevels]'
})
export class CheckAccountLevelsDirective {
  @Input() actionByLevels: string;
  // TODO this is a mandatory property. We need to figure out how to force devs define it when using this directive
  @Input() wallName: string;
  @Input() actionData: any;
  @Output() afterChecking = new EventEmitter<any>();

  constructor( private elementRef: ElementRef,
               private userService: UserService,
               private eventTracker: EventTrackerService) { }

  @HostListener('click', ['$event']) onClick(evt) {
    this.internalValidatePermission(evt);
  }

  @HostListener('keydown', ['$event'])
  onKeypress(evt: KeyboardEvent) {
    this.internalValidatePermission(evt);
  }

  private internalValidatePermission(evt) {
    // do not validate permission for admin
    if (this.userService.isAdmin || this.userService.isInfluencer) {
      this.afterChecking.emit(evt);
      return;
    }
    const limitations = this.userService.accountLimitations;
    if (!this.actionByLevels || !limitations) {
      return ;
    }

    const actionPermission = limitations.find(l => l.featureName === this.actionByLevels);
    if (actionPermission && !actionPermission.activated) {
      this.userService.doInvalidActionByLevel(this.actionByLevels);
      this.trackInvalidAction();
      evt.preventDefault();
      evt.stopPropagation();
      evt.stopImmediatePropagation();
    } else {
      this.afterChecking.emit(evt);
    }
  }

  private trackInvalidAction() {
    if (!this.actionData) {
      return;
    }
    const wallName = this.wallName ? this.wallName : this.actionByLevels;
    const detailsAction = new InvalidAction(true, BlockedReason.ACCOUNT_WALL, WallType.FEATURE_UNAVAILABLE,
      wallName, false, null, null, this.userService.currentUserLevel.name);
    this.eventTracker.trackUserInvalidAction(detailsAction, this.actionData.action, this.actionData.item,
      this.actionData.target, this.actionData.params, this.actionData.report, this.actionData.activePage,
      this.actionData.extraProperties);
  }
}



// WEBPACK FOOTER //
// ./src/app/directive/check-account-levels.directive.ts